"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Avatar", {
    enumerable: true,
    get: function() {
        return Avatar;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _Theme = require("../../contexts/Theme");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const backgroundColors = [
    "#67CD89",
    "#CD6767",
    "#D564DF",
    "#7C55EA",
    "#CDB067"
];
const getBackgroundColor = (firstName, lastName)=>{
    const res = firstName + lastName;
    const ascii = res.split("").filter((char)=>char !== " ").reduce((accum, item)=>{
        return accum + (!isNaN(item.charCodeAt(0)) ? item.charCodeAt(0) : 0);
    }, 0);
    return backgroundColors[ascii % backgroundColors.length];
};
const Avatar = (param)=>{
    let { firstName, lastName, imageUrl, badge, size = "medium", className = "" } = param;
    const { colors, isAdmin } = (0, _Theme.useTheme)();
    const [noImageFound, setNoImageFound] = (0, _react.useState)(imageUrl == null);
    (0, _react.useEffect)(()=>{
        setNoImageFound(imageUrl == null);
    }, [
        imageUrl
    ]);
    const content = (0, _react.useMemo)(()=>{
        if (imageUrl != null && !noImageFound) {
            return /*#__PURE__*/ _react.default.createElement("img", {
                src: imageUrl,
                onError: ()=>setNoImageFound(true)
            });
        }
        var _firstName_, _lastName_;
        return "".concat((_firstName_ = firstName === null || firstName === void 0 ? void 0 : firstName[0]) !== null && _firstName_ !== void 0 ? _firstName_ : "").concat((_lastName_ = lastName === null || lastName === void 0 ? void 0 : lastName[0]) !== null && _lastName_ !== void 0 ? _lastName_ : "");
    }, [
        firstName,
        lastName,
        imageUrl,
        noImageFound,
        setNoImageFound
    ]);
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("span", {
        className: _style.default.dynamic([
            [
                "8ddf72fafcd6a7a9",
                [
                    getBackgroundColor(firstName !== null && firstName !== void 0 ? firstName : "", lastName !== null && lastName !== void 0 ? lastName : ""),
                    colors.white,
                    colors.transparent.black[5],
                    colors.blue[100]
                ]
            ]
        ]) + " " + "avatar avatar-".concat(size, " ").concat(className)
    }, content, badge != null && /*#__PURE__*/ _react.default.createElement("span", {
        className: _style.default.dynamic([
            [
                "8ddf72fafcd6a7a9",
                [
                    getBackgroundColor(firstName !== null && firstName !== void 0 ? firstName : "", lastName !== null && lastName !== void 0 ? lastName : ""),
                    colors.white,
                    colors.transparent.black[5],
                    colors.blue[100]
                ]
            ]
        ]) + " " + "avatar-badge avatar-badge-".concat(size, " ").concat(isAdmin && "avatar-badge-admin")
    }, badge)), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "8ddf72fafcd6a7a9",
        dynamic: [
            getBackgroundColor(firstName !== null && firstName !== void 0 ? firstName : "", lastName !== null && lastName !== void 0 ? lastName : ""),
            colors.white,
            colors.transparent.black[5],
            colors.blue[100]
        ]
    }, ".avatar.__jsx-style-dynamic-selector{font-weight:500;letter-spacing:.04em;-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%;position:relative;display:inline-block;text-align:center;vertical-align:middle;background-color:".concat(getBackgroundColor(firstName !== null && firstName !== void 0 ? firstName : "", lastName !== null && lastName !== void 0 ? lastName : ""), ";color:").concat(colors.white, ';position:relative}.avatar.__jsx-style-dynamic-selector:after{content:"";position:absolute;top:0;right:0;bottom:0;left:0;border:1px solid ').concat(colors.transparent.black[5], ";-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%;z-index:0}.avatar-x-large.__jsx-style-dynamic-selector{width:104px;height:104px;line-height:104px;font-size:32px}.avatar-large.__jsx-style-dynamic-selector{width:40px;height:40px;line-height:40px;font-size:14px}.avatar-medium.__jsx-style-dynamic-selector{width:32px;height:32px;line-height:32px;font-size:12px}.avatar-small.__jsx-style-dynamic-selector{width:24px;height:24px;line-height:24px;font-size:10px}.avatar-badge.__jsx-style-dynamic-selector{display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;position:absolute;width:16px;height:16px;-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%;background:").concat(colors.blue[100], ";z-index:1}.avatar-badge-admin.__jsx-style-dynamic-selector{background:-webkit-linear-gradient(172.48deg,#ff794c -65.2%,rgba(225,85,162,.37)76.96%,rgba(225,85,162,0)131.25%),-webkit-linear-gradient(330.42deg,rgba(0,0,170,.9)-22.08%,#c931ff 231.23%),#fff;background:-moz-linear-gradient(172.48deg,#ff794c -65.2%,rgba(225,85,162,.37)76.96%,rgba(225,85,162,0)131.25%),-moz-linear-gradient(330.42deg,rgba(0,0,170,.9)-22.08%,#c931ff 231.23%),#fff;background:-o-linear-gradient(172.48deg,#ff794c -65.2%,rgba(225,85,162,.37)76.96%,rgba(225,85,162,0)131.25%),-o-linear-gradient(330.42deg,rgba(0,0,170,.9)-22.08%,#c931ff 231.23%),#fff;background:linear-gradient(277.52deg,#ff794c -65.2%,rgba(225,85,162,.37)76.96%,rgba(225,85,162,0)131.25%),linear-gradient(119.58deg,rgba(0,0,170,.9)-22.08%,#c931ff 231.23%),#fff}.avatar-badge-small.__jsx-style-dynamic-selector{-webkit-transform:scale(.75);-moz-transform:scale(.75);-ms-transform:scale(.75);-o-transform:scale(.75);transform:scale(.75);top:-3px;right:-3px}.avatar-badge-medium.__jsx-style-dynamic-selector{-webkit-transform:scale(1);-moz-transform:scale(1);-ms-transform:scale(1);-o-transform:scale(1);transform:scale(1);top:-2px;right:-2px}.avatar-badge-large.__jsx-style-dynamic-selector{-webkit-transform:scale(1);-moz-transform:scale(1);-ms-transform:scale(1);-o-transform:scale(1);transform:scale(1);top:-2px;right:-2px}.avatar.__jsx-style-dynamic-selector img{width:100%;height:100%;-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%;display:block}")));
};

//# sourceMappingURL=Avatar.js.map